<template>
    <div></div>
</template>
<script>
export default {
    props: ['capteraKey', 'vid'],
    computed: {
        capteraUrl() {
            return `https://ct.capterra.com/capterra_tracker.js?vid=${this.vid}&vkey=${this.capteraKey}`;
        }
    },
    created() {
        const capteraScript = document.createElement('script');
        capteraScript.type = 'text/javascript';
        capteraScript.async = true;
        capteraScript.src = this.capteraUrl;
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(capteraScript, s);
    }
};
</script>
